import styled from "styled-components";
import LogoSinsoft from "../../Assets/logo-sinsoft.png"; // Importe a imagem
import { site_sinsoft_url } from "../../Utils/Urls";
import { useEntidade } from "../../Hooks/EntidadeHook";

const StyledImage = styled.img`
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  /* Adicione estilos adicionais aqui, se necessário */
`;

interface Props {
  w?: number;
}
export const Logo = ({ w }: Props) => {
  const { entidadeFocus } = useEntidade();
  return (
    <>

      <StyledImage
        src={entidadeFocus.logo || LogoSinsoft}
        alt="Logo Sinsoft"
        onClick={() => {
          window.open(site_sinsoft_url, "_blank");
        }}
        style={{ width: w ? w : "135px" }}
      />
    </>

  );
};
